import React from 'react';

/**
 * Premium Loading Component
 * @param {string} mode - 'full' (fullscreen overlay), 'page' (centered in page), 'inline' (centered in container), 'button' (small for buttons)
 * @param {string} message - Optional message to display
 */
export default function Loading({ mode = 'page', message = 'Loading...' }) {
    const baseSpinner = (
        <div className="relative">
            <div className={`
                rounded-full border-4 border-primary-100 
                ${mode === 'button' ? 'w-5 h-5 border-2' : 'w-12 h-12'}
            `}></div>
            <div className={`
                absolute top-0 left-0 rounded-full 
                border-4 border-primary-600 border-t-transparent animate-spin
                ${mode === 'button' ? 'w-5 h-5 border-2' : 'w-12 h-12'}
            `}></div>
        </div>
    );

    if (mode === 'full') {
        return (
            <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm">
                <div className="flex flex-col items-center space-y-4 p-8 rounded-2xl bg-white shadow-2xl border border-primary-50">
                    {baseSpinner}
                    {message && (
                        <p className="text-primary-900 font-bold text-lg animate-pulse">
                            {message}
                        </p>
                    )}
                </div>
            </div>
        );
    }

    if (mode === 'page') {
        return (
            <div className="flex flex-col items-center justify-center py-20 w-full animate-in fade-in duration-500">
                {baseSpinner}
                {message && <p className="mt-4 text-gray-500 font-medium">{message}</p>}
            </div>
        );
    }

    if (mode === 'button') {
        return (
            <div className="flex items-center justify-center space-x-2">
                {baseSpinner}
                {message && <span>{message}</span>}
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center p-4">
            {baseSpinner}
            {message && <span className="ml-3 text-gray-500">{message}</span>}
        </div>
    );
}
